
define('text!app-SearchResults/modules/batBelt/view.html',[],function () { return '<h1><span data-bind="text: TotalResults"></span> holidays found</h1>';});

